import {Injectable} from '@angular/core';
import {GlobalDataService} from '../../housekeeping/services/global-data.service';
import {GlobalVariable} from '../../../../app/config';

@Injectable()
export class AdminService {
    public apiendpoint_url = GlobalVariable.FORDAPIEndPointURL;
  constructor(private _globalDataService:GlobalDataService) { }

    
  
  /**
   * @author Anand
   * @uses Get user roles
   */
   getTimezonelist(callback) {
        this._globalDataService.GetAjaxCall(this.apiendpoint_url + '/user/timezone/list', (result) => {
            callback(result);
        });
    }
  
  
  /**
   * @author Anand
   * @uses Get user roles
   */

    getUserRoles(callback){
         this._globalDataService.GetAjaxCall(this.apiendpoint_url + '/lms/user/role/list', (result) => {
            callback(result);
        });
    }
    
    
    /**
   * @author Anand
   * @uses Get user dealer
   */

    getUserDealer(callback){
         this._globalDataService.GetAjaxCall(this.apiendpoint_url + '/lms/user/dealer/list', (result) => {
            callback(result);
        });
    }
    
     /**
   * @author Anand
   * @uses Get regions
   */

    getRegionList(callback){
         this._globalDataService.GetAjaxCall(this.apiendpoint_url + '/lms/user/region/list', (result) => {
            callback(result);
        });
    }
    
    /**
     * @author Anand
     * @uses Save user
     */
    saveUser(params,callback){
         this._globalDataService.PostAjaxCall(this.apiendpoint_url + '/lms/user/save/',params, (result) => {
            callback(result);
        });

    }
    /**
     * @author Nagendra
     * @param userId, offset, limit, callback
     * @description To get UserList 
     */
    getUserList(userId, offset, limit, callback) {
        this._globalDataService.GetAjaxCall(this.apiendpoint_url + "/lms/user/list?userId=" + userId + "&offset=" + offset + "&pageLimit=" + limit, result => {
            callback(result);
        })
    }
    
     /**
      * @author Nagendra
      * @uses   Basic search for User List
      */
     adminBasicSearch(userId,searchKey,offset,limit,callback){
          this._globalDataService.GetAjaxCall(this.apiendpoint_url + "/lms/user/search?userId="+userId+"&searchKey="+searchKey+"&offset="+offset+"&pageLimit="+limit, (result) => {
            callback(result);
        })
     }
     
      /**
      * @author Nagendra
      * @uses   Advance search for User List
      */
     adminAdvanceSearch(searchObj,callback){
          this._globalDataService.PostAjaxCall(this.apiendpoint_url + "/lms/user/searchWider",searchObj, (result) => {
            callback(result);
        })
     }
     
    /**
    *@author Nagendra
    *@description For Dealer List
    */
    getDealerList(userId,callback) {
         this._globalDataService.GetAjaxCall(this.apiendpoint_url + "/lms/dealer/list?userId="+userId,(result) => {
            callback(result);
        })
    }
    
    /**
    *@author Sowmya
    *@description For user detail
    */
    getAdminDetails(userId,callback) {
         this._globalDataService.GetAjaxCall(this.apiendpoint_url + "/lms/user/details?userId="+userId,(result) => {
            callback(result);
        })
    }
    
     /**
    *@author Anand
    *@description Delete user
    */
    deleteUser(userId,callback) {
         this._globalDataService.GetAjaxCall(this.apiendpoint_url + "/lms/user/delete?userId="+userId,(result) => {
            callback(result);
        })
    }
    
    verifyEmail(userId,email,callback){
         this._globalDataService.GetAjaxCall(this.apiendpoint_url + "/lms/user/emailValidation?userId="+userId+"&email="+email,(result) => {
            callback(result);
        },false);
    }
    
    startSync(userId,callback) {
         this._globalDataService.GetAjaxCall(this.apiendpoint_url + "/lms/sync",(result) => {
            callback(result);
        })
    }
      updatePageLimit(userId, limit,callback){
       this._globalDataService.GetAjaxCall(this.apiendpoint_url + "/lms/user/updatePageLimit?userId=" + userId + "&pageLimit=" + limit, result => {
            callback(result);
        
        })
      }
      getCountryList(userid,callback){
        this._globalDataService.GetAjaxCall(this.apiendpoint_url + "/lms/country/list", (result) => {
            callback(result);
        })
    }
    
}



// WEBPACK FOOTER //
// ./src/app/modules/admin/services/admin.service.ts